export class CancelamentoModel{
    public Id: number;
    public UUID: string;
    public Motivo: number;
}